import * as yup from "yup";

const requiredFieldMessage = "All fields are required";
const minValueMessage = "Min value must be less than max value";
const maxValueMessage = "Max value must be greater than min value";

const createWeightVolumeSchema = (size: string) =>
  yup.object({
    minWeight: yup
      .string()
      .required(requiredFieldMessage)
      .test("is-less-than-maxWeight", minValueMessage, function (value) {
        const { maxWeight } = this.parent;
        return size === "s" || +value < +maxWeight;
      }),
    maxWeight: yup
      .string()
      .required(requiredFieldMessage)
      .test("is-greater-than-minWeight", maxValueMessage, function (value) {
        const { minWeight } = this.parent;
        return +value > +minWeight;
      }),
    minVolume: yup
      .string()
      .required(requiredFieldMessage)
      .test("is-less-than-maxVolume", minValueMessage, function (value) {
        const { maxVolume } = this.parent;
        return +value < +maxVolume;
      }),
    maxVolume: yup
      .string()
      .required(requiredFieldMessage)
      .test("is-greater-than-minVolume", maxValueMessage, function (value) {
        const { minVolume } = this.parent;
        return +value > +minVolume;
      })
  });

export const parcelSizesSchema = yup.object({
  s: createWeightVolumeSchema("s"),
  m: createWeightVolumeSchema("m"),
  l: createWeightVolumeSchema("l")
});
